import { Box, Button, CardContent, TextField, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";

const DescriptionSection = ({
  isEditingDescription,
  toggleEditDescription,
  isAnyButtonInEditMode,
  errors,
  formData,
  handleChange,
  isEditModePersonalInformation
}) => {
  return (
    <CardContent
      sx={{
        borderRadius: 2,
        mb: 2,
        backgroundColor: "rgba(211, 211, 211, 0.26)",
        "& .MuiOutlinedInput-root": {
          backgroundColor: "rgba(211, 211, 211, 0.26)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Description</Typography>
        <Button
          startIcon={
            isEditingDescription ? (
              <SaveIcon sx={{ color: Object.keys(errors).length > 0 ? 'grey' : '#1E40AF' }} />
            ) : (
              <EditIcon sx={{ color: 'grey' }} />
            )
          }
          size="small"
          sx={{
            borderRadius: 2,
            border: "1px solid #D3D3D3",
            backgroundColor: "transparent",
            color: isEditModePersonalInformation && Object.keys(errors).length === 0 ? '#1E40AF' : 'grey',
            "&:hover": {
              borderColor: "#1E40AF",
              color: "#1E40AF",
            },
          }}
          onClick={toggleEditDescription}
          disabled={(isAnyButtonInEditMode && !isEditingDescription) || Object.keys(errors).length > 0}
        >
          {isEditingDescription ? "Save" : "Edit"}
        </Button>
      </Box>

      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Tell customers about your services and expertise:
      </Typography>

      {isEditingDescription ? (
        <>
          <TextField
            value={formData.description}
            name="description"
            onChange={handleChange}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            sx={{ p: 2 }}
          />

          <Typography
            variant="caption"
            color="text.secondary"
            align="right"
            sx={{ display: "block" }}
          >
            Character limit: {formData.description.length}/500
          </Typography>

          {errors.description && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              {errors.description}
            </Typography>
          )}
        </>
      ) : (
        <Typography variant="body2" paragraph sx={{ p: 2 }}>
          {formData?.description || "No description available."}
        </Typography>
      )}
    </CardContent>
  );
};

export default DescriptionSection;
